<template>
    <el-footer class="footer">
        <p>北京市勘察设计研究院有限公司 版权所有 ©2021 All Rights Reserved.</p>
        <p>公司地址：中国北京复兴门外羊坊店路15号 | 邮政编码：100038 | 人力资源部 咨询电话：(+86-10)&nbsp;010-63951970</p>
        <p>技术支持：北京市勘察设计研究院有限公司 信息技术中心</p>
    </el-footer>
</template>

<script>
    export default {}
</script>

<style scoped lang="less">
    .footer {
        padding: 20px 0 20px 0;
        height: 110px !important;
        width: 100%;
        background: #006eab;
        color: #cfcfcf;
        line-height: 25px;
        font-size: 14px;
    }
</style>
